import * as _1 from "../confio/proofs";
const ics23 = {
  ..._1
};
export {
  ics23
};
